module.exports = "/assets/fe0b47c15756c36d9bb2ca6f945ff382.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/JP.png
// module id = 2642
// module chunks = 0